import type { Theme } from '@mui/material/styles'
import type { SystemStyleObject } from '@mui/system'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'

import texts from '../../texts'
import { Icons } from '../../../assets'
import { useDocumentScrollManipulationForModal } from '../hooks'
import styles from './modal.styles'

interface ModalProps {
  open: boolean
  onClose: () => void
  title?: string
  renderInHeader?: () => React.ReactNode
  sx?: SystemStyleObject<Theme>
  children: React.ReactNode
}

const Modal = ({
  open,
  onClose,
  title,
  renderInHeader,
  sx = {},
  children,
}: ModalProps) => {
  useDocumentScrollManipulationForModal(open)

  return (
    <Box sx={[styles.root, sx]} className={open ? '' : 'hidden'}>
      <Box id='p-modal-close-button'>
        <Box>
          <IconButton
            aria-label={texts.close}
            color='inherit'
            onClick={onClose}
          >
            <Icons.Close />
          </IconButton>
        </Box>
      </Box>
      <Box sx={styles.wrapper}>
        <Box sx={styles.fixed} className='full-bleed'>
          {Boolean(title) && (
            <Typography variant='h4' sx={styles.lineClamp}>
              {title}
            </Typography>
          )}
          {renderInHeader !== undefined && renderInHeader()}
        </Box>
        <Box sx={styles.content}>{children}</Box>
      </Box>
    </Box>
  )
}

export default Modal
